import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@fluentui/react/lib/Stack';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getStyles } from './styles';


function SummaryBar(props) {
  const { children, className } = props;
  const classes = useDefaultStyles(getStyles);

  return (
    <Stack className={`${className} ${classes['reports-v4-summary-bar']}`} horizontal>
      {children}
    </Stack>
  );
}

SummaryBar.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

SummaryBar.defaultProps = {
  className: '',
};

export { SummaryBar };
